
import {
  PEImmigrationBenefitsCardActions, PEImmigrationBenefitsCardGetters, PEImmigrationBenefitsCardMutations,
} from './pe-immigration-benefits-card'
import {
  PEImmigrationProceedingsCardActions, PEImmigrationProceedingsCardGetters, PEImmigrationProceedingsCardMutations,
} from './pe-immigration-proceedings-card'
import { PEIncomeCardActions, PEIncomeCardGetters, PEIncomeCardMutations } from './pe-income-card'
import { PELanguagesCardActions, PELanguagesCardGetters, PELanguagesCardMutations } from './pe-languages-card'
import {
  PETravelHistoriesCardActions, PETravelHistoriesCardGetters, PETravelHistoriesCardMutations,
} from './pe-travel-histories-card'

export const BackgroundSectionActions = {
  ...PEImmigrationBenefitsCardActions,
  ...PEImmigrationProceedingsCardActions,
  ...PEIncomeCardActions,
  ...PELanguagesCardActions,
  ...PETravelHistoriesCardActions,
}

export const BackgroundSectionGetters = {
  ...PEImmigrationBenefitsCardGetters,
  ...PEImmigrationProceedingsCardGetters,
  ...PEIncomeCardGetters,
  ...PELanguagesCardGetters,
  ...PETravelHistoriesCardGetters,
}

export const BackgroundSectionMutations = {
  ...PEImmigrationBenefitsCardMutations,
  ...PEImmigrationProceedingsCardMutations,
  ...PEIncomeCardMutations,
  ...PELanguagesCardMutations,
  ...PETravelHistoriesCardMutations,
}
